import React, { useEffect } from "react";
import "./App.css";
import { HashRouter, Switch, Route } from "react-router-dom";
import history from "./services/history";
import "bootstrap/dist/css/bootstrap.min.css";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { esES } from "@material-ui/core/locale";
import { connect } from "react-redux";
import { matchPath } from "react-router";
import CssBaseline from "@material-ui/core/CssBaseline";
import LogIn from "./components/screens/LogIn/LogIn";
import NuevaPresentacion from "./components/screens/Prestadores/NuevaPresentacion";
import EditarPresentacion from "./components/screens/Prestadores/EditarPresentacion";
import VerPresentacion from "./components/screens/Prestadores/VerPresentacion";
import GrillaPrincipal from "./components/screens/GrillaPrincipal/GrillaPrincipal";

import RubikRegular from "./assets/fonts/Rubik-Regular.ttf";
import RobotoRegular from "./assets/fonts/Roboto-Regular.ttf";

import * as AuthActions from "./actions/auth";
import * as ventanaDialogoActions from "./actions/ventanaDialogo";
import HeaderGaleno from "./components/common/Header/Header";
import SnackMensaje from "./components/common/SnackBar/SnackBar";
import VentanaDialogo from "./components/common/Dialog/VentanaDialogo";
import { Box, CircularProgress } from "@material-ui/core";
import SinResultado from "./components/GrillaPrincipal/SinResultado/SinResultado";

import { setToken } from "./http-common";

const rubik = {
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontDisplay: "swap",
    fontWeight: 400,
    src: `
    local('Rubik-Regular'),
    url(${RubikRegular}) format('truetype')
  `,
    unicodeRange:
        "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

const roboto = {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontDisplay: "swap",
    fontWeight: 400,
    src: `
    local('Roboto-Regular'),
    url(${RobotoRegular}) format('truetype')
  `,
    unicodeRange:
        "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

const theme = createMuiTheme(
    {
        palette: {
            primary: {
                main: "#02599E",
            },
            secondary: {
                main: "#02A48D",
            },
        },
        typography: {
            fontFamily: "Rubik, Roboto, Arial",
        },
        overrides: {
            MuiCssBaseline: {
                "@global": {
                    "@font-face": [rubik, roboto],
                    ".MuiButton-root": {
                        "&:focus": {
                            outline: "none",
                        },
                    },
                    ".MuiButtonBase-root": {
                        "&:focus": {
                            outline: "none",
                        },
                    },
                    ".MuiBackdrop-root": {
                        backgroundColor: "rgba(255, 255, 255, 0.5) !important",
                    },
                    ".MuiMenuItem-root": {
                        fontWeight: "300 !important",
                        fontSize: "14px !important",
                        lineHeight: "16px !important",
                        letterSpacing: "-0.01em  !important",
                    },
                },
            },
        },
    },
    esES
);

const App = (props) => {
    useEffect(() => {
        let match = null;
        if (
            (match = matchPath(history.location.pathname, {
                path: "/token/:token",
            }))
        ) {
            //nuevo token
            setToken(match.params.token);
            props.setToken(match.params.token);
            props.getInformacionUsuario();
            history.push("/");
        } else if (sessionStorage.getItem("token")) {
            //token de sessionStorage
            const token = sessionStorage.getItem("token");
            setToken(token);
            props.setToken(token);
            props.getInformacionUsuario();
            if (
                matchPath(history.location.pathname, {
                    path: "/login",
                })
            )
                history.push("/");
        } else {
            //no encontro token
            history.push("/login");
            localStorage.clear();
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {props.token && (
                <HeaderGaleno
                    codPrestador={
                        props.prestadorActivo &&
                        props.prestadorActivo.codPrestador
                    }
                />
            )}
            <HashRouter history={history}>
                <Switch>
                    {/* <Route exact path="/sesion-expirada">
                        <Box height="100vh" display="flex" alignItems="center">
                            <SinResultado mensaje="Su sesión ha expirado" />
                        </Box>
                    </Route> */}
                    <Route exact path="/login">
                        <LogIn />
                    </Route>
                    <Route exact path="/token/:token">
                        <Box height="100vh" display="flex" alignItems="center">
                            <CircularProgress />
                        </Box>
                    </Route>
                    {/* <Route exact path="/token/:token">
                        <Redirect />
                    </Route> */}
                </Switch>
                {props.token && (
                    <Switch>
                        <Route exact path="/nueva">
                            <NuevaPresentacion />
                        </Route>
                        <Route exact path="/ver/:idPresentacion/:idTipoPresentacion">
                            <VerPresentacion />
                        </Route>
                        <Route exact path="/editar/:idPresentacion/:idTipoPresentacion">
                            <EditarPresentacion />
                        </Route>
                        <Route exact path="/">
                            <GrillaPrincipal />
                        </Route>
                        <Route path="*">
                            <Box
                                height="100vh"
                                display="flex"
                                alignItems="center"
                            >
                                <SinResultado mensaje="Página no encontrada" />
                            </Box>
                        </Route>
                    </Switch>
                )}
            </HashRouter>
            <VentanaDialogo
                titulo={props.titulo}
                mostrar={props.estaVisible}
                contenido={props.contenido}
                mensaje={props.mensaje}
                clickSuccess={props.clickAceptar}
                clickCancelar={props.clickCancelar}
                deshabilitarAceptar={props.deshabilitarAceptar}
                textoBtnAceptar={props.textoBtnAceptar}
                esAlerta={props.esAlerta}
                maxWidth={props.maxWidth}
                whiteSpace={props.whiteSpace}
            />
            <SnackMensaje
                mostrar={props.mostrarSnack}
                mensaje={props.mensajeSnack}
            />
        </ThemeProvider>
    );
};

const mapStateToProps = (state) => ({
    ...state.ventanaDialogoReducer,
    ...state.snackMensajeReducer,
    ...state.authReducer,
});

const actionCreators = {
    setToken: AuthActions.setToken,
    getInformacionUsuario: AuthActions.getInformacionUsuario,
    actualizarAtriutoVentanaDialogo:
        ventanaDialogoActions.actualizarAtriutoVentanaDialogo,
};

export default connect(mapStateToProps, actionCreators)(App);
